import { render, staticRenderFns } from "./Borrower.vue?vue&type=template&id=4b6387f5&scoped=true&"
import script from "./Borrower.vue?vue&type=script&lang=js&"
export * from "./Borrower.vue?vue&type=script&lang=js&"
import style0 from "./Borrower.vue?vue&type=style&index=0&id=4b6387f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6387f5",
  null
  
)

export default component.exports